export default {
  NEWS_DETAIL: 'news-detail',
  ACTOR_DETAIL: 'actor-detail',
  INDEX: 'index',
  SCHEDULES: 'schedules',
  DISCOVERY: 'news',
  MY: 'my',
  MY_TICKETS: 'myTickets',
  MY_COUPONS: 'myCoupons',
  PERFORMS: 'performs',
  SEAT: 'seat',
  MEMBER_CENTER: 'memberCenter',
  MEMBER_RIGHTS: 'memberRights',
  MEMBER_INFO: 'memberInfo',
  MEMBER_AGREEMENT: 'memberAgreement',
  SERVICE_AGREEMENT: 'serviceAgreement',
  PRIVACY_POLICY: 'privacyPolicy',
  ABOUT: 'about',
  SITE_FACILITIES: 'siteFacilities',
  PARTNER: 'partner',
  ORDER_DETAIL: 'orderDetail',
  ORDER_CONFIRM: 'orderConfirm',
  COUPON_DETAIL: 'couponDetail',
  FIND_PASSWORD: 'findPassword',
  MODIFY_PASSWORD: 'modifyPassword',
  LOGIN: 'login',
  ERROR: 'error',
  FAQ: 'faq',
  FAQ_DETAIL: 'faqDetail',
  ERROR_MESSAGE: 'error-message',
  REFUND_ACCOUNT: 'refund-account',
  SHOP: 'shop',
  VOUCHER_SUBMIT: 'voucher-submit'
}



// WEBPACK FOOTER //
// ./src/constants/page.js